import './NotFoundPage.scss';
import NotFoundImg from '../../components/ui/images/404.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
  const { t } = useTranslation('global');
  const navigate = useNavigate();

  return (
    <div className='notFound container'>
        <img src={NotFoundImg} alt='404' />
        <h3>{t('notFound.title')}</h3>
        <p style={{color:'#838282'}}>{t('notFound.description')}</p>
        <button onClick={()=>navigate('/')} className='notFound__btn'>{t('notFound.goHome')}</button>
    </div>
  )
}

export default NotFoundPage